export const PAGE_LOADING_ASYNC_OPERATION_ID = 'page-pageData'
